import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
  private translateService = inject(TranslateService);

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const rawTitle = this.buildTitle(routerState);
    if (!rawTitle) {
      this.translateService.get('APP_TITLE').subscribe((appTitle: string) => {
        this.title.setTitle(typeof appTitle === 'string' && appTitle ? appTitle : 'Vult Super Admin');
      });
      return;
    }

    if (typeof rawTitle === 'object') {
      const lang = this.translateService.currentLang || localStorage.getItem('lang') || 'ar';
      const localized = (rawTitle as Record<string, string>)[lang] || (rawTitle as Record<string, string>)['ar'] || (rawTitle as Record<string, string>)['en'] || '';
      this.title.setTitle(localized ? `Vult - ${localized}` : 'Vult Super Admin');
      return;
    }

    if (typeof rawTitle === 'string') {
      this.translateService.get([rawTitle, 'APP_TITLE_BASE']).subscribe((translations: any) => {
        const base = translations['APP_TITLE_BASE'] || 'Vult';
        const page = translations[rawTitle] || rawTitle;
        this.title.setTitle(`${base} - ${page}`);
      });
    }
  }

  // Optional: Override buildTitle to extract title from route data
  override buildTitle(routerState: RouterStateSnapshot): string | undefined {
    let route = routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.data['title'] || undefined;
  }
}